export default __webpack_public_path__ + "static/media/MightyMagnets_00.6af9427e.png";